<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <v-data-iterator
            :items="items"
            hide-default-footer>
        <template v-slot:item="props">
            <v-row>
                <v-col :cols="12">
                    <v-card>
                        <v-list dense>
                            <v-list-item>
                                <v-list-item-content>Pulse Level:</v-list-item-content>
                                <v-list-item-content>{{ props.item.torchLevel }}</v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>Flash Status:</v-list-item-content>
                                <v-list-item-content>{{ props.item.flashOn }}</v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>Video Duration:</v-list-item-content>
                                <v-list-item-content>{{ props.item.videoDuration }}</v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>Pulse Duration:</v-list-item-content>
                                <v-list-item-content>{{ props.item.torchDuration }}</v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>Ambient Adapt Brightness Level:</v-list-item-content>
                                <v-list-item-content>{{ props.item.ambientLevel }}</v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>Illumination Delay:</v-list-item-content>
                                <v-list-item-content>{{ props.item.illuminationDelay }}</v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>Dropped Frames Count:</v-list-item-content>
                                <v-list-item-content>{{ props.item.droppedFramesCount }}</v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>Produced with Reflex version:</v-list-item-content>
                                <v-list-item-content>{{ props.item.processedBy }}</v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="props.item.testProtocolTag">
                                <v-list-item-content>Test Protocol Tag:</v-list-item-content>
                                <v-list-item-content>{{ props.item.testProtocolTag }}</v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-col>
            </v-row>
        </template>
    </v-data-iterator>
</template>

<script>
    import { mapState } from 'vuex'
    import { formatNumber } from '@/store/tests'

    export default
    {
        name: 'test-meta-data',
        data: function()
        {
            return {
                items:
                [
                    {
                        torchLevel: 0,
                        flashOn: '',
                        videoDuration: 0,
                        torchDuration: 0,
                        ambientLevel: 0,
                        illuminationDelay: 0,
                        droppedFramesCount: 0,
                        processedBy: '',
                        testProtocolTag: null
                    }
                ]
            }
        },
        props:
        {
            resultData: {}
        },
        computed:
        {
            ...mapState('auth',
            {
                currentUser: state => state.currentUser
            })
        },
        watch:
        {
            resultData()
            {
                this.resultDataCommon()
            }
        },
        mounted()
        {
            this.resultDataCommon()
        },
        methods:
        {
            resultDataCommon: function()
            {
                this.items[0].torchLevel = !this.resultData.metaData.flashOn && this.resultData.metaData.torchLevel ? `${formatNumber(this.resultData.metaData.torchLevel * 100)}%` : 'N/A';
                this.items[0].flashOn = this.resultData.metaData.flashOn ? 'On' : 'Off';
                this.items[0].videoDuration = `${formatNumber(this.resultData.metaData.videoDuration)} sec`;
                this.items[0].torchDuration = !this.resultData.metaData.flashOn && this.resultData.metaData.torchDuration ? `${formatNumber(this.resultData.metaData.torchDuration)} sec` : 'N/A';
                this.items[0].ambientLevel = this.resultData.metaData.ambientLevel ? `${formatNumber(this.resultData.metaData.ambientLevel * 100)}%` : 'N/A';
                this.items[0].illuminationDelay = this.resultData.metaData.illuminationDelay ? `${formatNumber(this.resultData.metaData.illuminationDelay)} sec` : 'N/A';
                this.items[0].droppedFramesCount = `${this.resultData.metaData.droppedFrames.length} frame${this.resultData.metaData.droppedFrames.length !== 1 ? 's' : ''}`;
                this.items[0].processedBy = this.resultData.metaData.processedBy != null ? this.resultData.metaData.processedBy : 'N/A';
                this.items[0].testProtocolTag = this.resultData.metaData.protoTag
            }
        }
    }
</script>

<style scoped>
</style>